import React from "react";
import { Header } from '../../Components/Layout/Header.jsx';
import { MetaTags } from '../../Components/Layout/MetaTags.jsx';
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx';
import { Game } from '../../Components/Game/Game.jsx';
import { GameDetails } from '../../Components/Game/GameDetails.jsx';
import { Redirect } from 'react-router';
import RiveComponent from "../../Components/Shared/RiveComponent";

export class CasinoUtrka extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            promotionText: 'Trajanje utrke',
            startPromotion: false,
            timerNajava: null,
            countDownTimer: null,
            promotionFinished: false,
            start: null,
            end: null,
            tabs: ['Popis igara', 'Nagradni fond'],
            selectedTab: 'Popis igara',
            games: null,
            categories: null,
            race: null,
            raceId: null,
            raceLoaded: false,
            navigate: false,
            resultsNumber: 10
        }

        this.setData = this.setData.bind(this);
        this.dohvatiIgre = this.dohvatiIgre.bind(this);
        this.renderIgra = this.renderIgra.bind(this);

        this.gameContainer = React.createRef();
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);

        let raceId = this.props.route.match && this.props.route.match.params && this.props.route.match.params.raceId;
        this.setState({ raceId: raceId });

        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn), casino.repos.casinoUtrkeIHGRepo.get(casino.config.casinoRestApiUrl, casino.config.casinoRestApiKey, raceId)]);

        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });

        setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);

        this.setState({ raceId: this.props.route.match && this.props.route.match.params && this.props.route.match.params.raceId });
    }

    componentWillUnmount() {
        clearInterval(this.state.countDownTimer);
        clearInterval(this.state.timerNajava);
    }

    setData(data) {
        var [games, categories, races] = data;
        this.setState({
            games: games,
            categories: categories.items,
            race: races[0],
            raceLoaded: true
        });

        if (races.length > 0) {
            var startDateTime = new Date(this.state.race.startTimeUTC);
            var endDateTime = new Date(this.state.race.endTimeUTC);

            if (new Date() < startDateTime) {
                this.startBannerCountDownTime(startDateTime);
            } else {
                this.startBannerCountDownTime(endDateTime);
            }

            this.checkPromotionDate(startDateTime, endDateTime);
            this.setState({ timerNajava: window.setInterval(() => this.checkPromotionDate(startDateTime, endDateTime), 1000) });

            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
            casino.utils.createPageGoogleTagManagerEvent('Casino Utrka', races[0].tournamentName, 'casino', this.props.user);

        }
        this.props.showLoadingFn(false);
    }

    dohvatiIgre() {
        var gamesArr = this.state.race.games
        var games = this.state.games
        var result = [];
        if (games) {
            gamesArr.forEach(x => {
                const foundGame = games.find(item => item.id == x.gameID);
                foundGame && result.push(foundGame)
            })
        }
        return result;
    }

    startBannerCountDownTime(endDateTime) {
        //Update the count down every 1 second
        var countDownTimer = setInterval(() => {
            // Get todays date and time
            var now = new Date().getTime();
            // Find the distance between now an the count down date
            var distance = endDateTime - now;

            // Time calculations for days, hours, minutes and seconds
            var days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
            var hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
            var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
            var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

            this.setState(() => {
                return {
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                }
            });

            // If the count down is finished, write some text
            if (distance < 0) {
                if (typeof countDownTimer !== 'undefined') {
                    clearInterval(countDownTimer);
                }
                this.setState(() => {
                    return {
                        days: '00',
                        hours: '00',
                        minutes: '00',
                        seconds: '00'
                    }
                });
            }
        }, 1000);

        this.setState({ countDownTimer: countDownTimer });
    }

    checkPromotionDate(startDateTime, endDateTime) {
        if ((new Date() < startDateTime) && this.state.startPromotion == false) {
            //Priprema
            this.setState({ promotionText: 'Do utrke' });
            if (!this.setState.countDownTimer) {
                this.startBannerCountDownTime(startDateTime);
            }
        } else if (new Date() > endDateTime) {
            this.setState({ promotionFinished: true });
            clearInterval(this.state.countDownTimer);
            clearInterval(this.state.timerNajava);
        }
        else {
            //Pocetak
            this.setState({ promotionText: 'Trajanje utrke' });

            if (this.state.countDownTimer && this.state.startPromotion == false) {
                clearInterval(this.state.countDownTimer);
                this.startBannerCountDownTime(endDateTime);
                this.setState({ startPromotion: true });
            }
        };
    }

    isPromotionStarted() {
        return new Date().getTime() >= new Date(this.state.race.startDate).getTime();
    }

    addDefaultSrc(e) {
        e.target.src = 'https://cdn.supersport.hr/IHG/default.jpg';
    }

    renderHeader() {
        return (
            <div>
                {this.state.race && <div className="cu-single-header">
                    <div className="text">
                        <div className="title-1">{this.state.race?.naziv}</div>
                    </div>
                    {this.state.race && this.state.race.startDate && <div className="start">
                        {this.isPromotionStarted() && 'Započelo: '}
                        {!this.isPromotionStarted() && 'Počinje: '}
                        {casino.utils.dateToShortDateString(new Date(this.state.race.startDate))}. u {casino.utils.dateToTimeString(new Date(this.state.race.startDate))}</div>}
                    <div className="promotion-text">{this.state.promotionText}</div>
                    <div className="counter">
                        <div className="number">
                            <div className="text-number">{this.state.days}</div>
                            <div className="text-footer">Dana</div>
                        </div>

                        <div className="number">
                            <div className="text-number">{this.state.hours}</div>
                            <div className="text-footer">Sati</div>
                        </div>

                        <div className="number">
                            <div className="text-number">{this.state.minutes}</div>
                            <div className="text-footer">Min</div>
                        </div>

                        <div className="number">
                            <div className="text-number">{this.state.seconds}</div>
                            <div className="text-footer">Sek</div>
                        </div>
                    </div>
                    <div className="rive-container">
                        <RiveComponent
                            lazyLoad={true}
                            cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                            src={`${casino.config.casinoCDNImagesUrl}/Banners/CasinoUtrke/casinoutrke_v1_web.riv`}
                            stateMachines="State Machine 1" 
                            useOffscreenRenderer={true}
                            playRequest={true}
                            disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }} 
                        />
                    </div>
                </div>
                }
                {this.state.race == undefined && this.state.raceLoaded &&
                    <div className="cu-single-header not-active">
                        <div className="text">
                            <div className="title-1">CASINO UTRKE</div>
                        </div>
                        <div className="rive-container">
                            <RiveComponent
                                lazyLoad={true}
                                cacheBust={`c=${casino.config.guiCacheVerzija}`} 
                                src={`${casino.config.casinoCDNImagesUrl}/Banners/CasinoUtrke/casinoutrke_v1_web.riv`}
                                stateMachines="State Machine 1"
                                useOffscreenRenderer={true}
                                playRequest={true}
                                disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px" }} 
                            />
                        </div>
                    </div>
                }
            </div>
        );
    }

    renderRaceInfo() {
        let imgUrl = this.state.race.image + '?c=' + casino.config.guiCacheVerzija;
        const firstReward = this.state.race.rewards.find(x => x.rank == "1").value;
        return <div>
            <div className="title">{this.state.race?.tournamentName}</div>
            <div className="title">Nagrada: <span className="red">{casino.utils.switchEurToKn(this.state.race?.rewardsSum) + ' ' + casino.utils.switchCurrencyKnToEur()}</span></div>
            <img className="race-image" src={imgUrl} onError={this.addDefaultSrc} ></img>
            <p className="race-info" dangerouslySetInnerHTML={{ __html: this.state.race?.description }}></p>
            <p>Igraj odabrane igre, skupljaj bodove i osvoji glavnu nagradu od <b>{casino.utils.numberWithCurrencyFromated(firstReward, 'EUR')}</b>.</p>

            <div className="divider"></div>
            {this.state.race && this.state.race.results?.length > 0 && <div>
                <div className="results-header">
                    <h2>Trenutni Poredak</h2>
                    <p className="results-info">Kreni u Casino Utrku što prije. Skupljaj bodove i uzmi svoj bonus.</p>
                </div>
                <div className="divider"></div>
                <table className="results">
                    <thead>
                        <tr>
                            <th>Plasman</th>
                            <th>Alias</th>
                            <th>Bodovi</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.race.results.slice(0, this.state.resultsNumber).map((player, index) => this.renderPlayerRow(player, index))}
                        {this.props.user && !this.state.race.results.find(it => it.isMe) && this.renderPlayerRow({ name: this.props.user.ime, rank: '..', points: 0 }, 9889)}
                    </tbody>
                </table>
                {this.state.resultsNumber < this.state.race.results.length && this.state.race.results.length > 10 && <div className="text-center">
                    <div className="show-more-block">
                        <button className="btn medium fill gray blue margin-top-small no-text-transform show-more" onClick={() => this.setState({ resultsNumber: this.state.resultsNumber + 10 })}>
                            <span className="icon ico-chevron-down"></span>
                            &nbsp; <span>Prikaži više</span>
                        </button>
                    </div>
                </div>}
                <p className="res-info">*<i>rezultati se osvježavaju svakih 5 minuta</i></p>
                <div className="divider"></div>
            </div>}
        </div>
    }

    renderPlayerRow(player, index) {
        return (
            <tr key={index} className={this.props.user && player.isMe ? 'selected' : ''}>
                <td>
                    {player.rank}.
                    {this.props.user && player.nickname == this.props.user.nadimak && <span className="mark"></span>}
                </td>
                <td>{player.name}</td>
                <td>{player.score}</td>
            </tr>
        )

    }

    renderRaceNotActive() {
        return <div>
            <div className="title">Utrka više nije aktivna</div>
        </div>
    }

    renderTabContent() {
        const pravilaLink = `${casino.config.casinoCDNDocumentsUrl}/Pravila/Pravila%20SuperCasino%20Utrka.pdf`;

        return <div>
            <div className="segment v2">
                {this.state.tabs && this.state.tabs.map((tab) =>
                    <button key={tab} onClick={() => this.goToTab(tab)} className={'segment--btn' + (this.state.selectedTab === tab ? ' selected' : '')}><span>{tab}</span></button>
                )}
            </div>
            {this.state.selectedTab === 'Popis igara' && this.renderPopisIgara()}
            {this.state.selectedTab === 'Nagradni fond' && this.renderNagradniFond()}
            <a className="btn-rules" target="_blank" href={pravilaLink + '?c=' + casino.config.guiCacheVerzija}>
                <span>Pravila igre</span>
            </a>

            {/*<p style={{ textAlign: "center", color: "#aa0d19", fontSize: "14px", fontWeight: "bold" }}>Izmjenjena su pravila promocije.</p>*/}

        </div>
    }

    goToTab(tab) {
        if (tab === "Popis igara") {
            setTimeout(() => casino.utils.lazyImages.mountEventLazyLoadImages(), 0);
        }
        this.setState({ selectedTab: tab });
    }

    renderPopisIgara() {
        return <div>
            <div className="title">Popis igara</div>
            <div id="game-container" className="maximum margin-center" ref={this.gameContainer}>
                <br></br>
                <div className={"clearfix white games-container"} style={(this.state.games && this.state.selectedCategoryId == -1) ? { padding: '0px' } : {}} >
                    {!this.state.games && <div>Dohvaćanje igara...</div>}
                    {this.state.games && this.state.race.games && this.dohvatiIgre().map(this.renderIgra)}
                </div>
            </div>
        </div>
    }

    renderIgra(igra, i) {
        return <Game brands={this.props.brands} categories={this.state.categories} routePrefix={"/casino-utrke/" + this.state.raceId} ref={"game-" + igra.id} key={igra.s} igra={igra} showJackpot={true} goLazyImage={true} fromNative={casino.config.fromNativeApp} fromNativeGameName={true} />;
    }

    renderNagradniFond() {
        let result = this.state.race.rewards;
        if (!result || result.length == 0)
            return '';
        var nagradeZadnji = result[result.length - 1].rank.split('-')



        return <div className="race-prize-fund">
            <div className="title">Nagradni fond u vrijednosti od <span className="red">{casino.utils.switchEurToKn(this.state.race?.rewardsSum) + ' ' + casino.utils.switchCurrencyKnToEur()}</span></div>
            {nagradeZadnji[nagradeZadnji.length - 1] && <div className="row">
                <span className="checkmark"></span>
                <span className="prize-money">  <span className="red">{casino.utils.switchEurToKn(this.state.race?.rewardsSum) + ' ' + casino.utils.switchCurrencyKnToEur()}</span> se djeli na {nagradeZadnji[nagradeZadnji.length - 1]} najbolje rangiranih igrača.</span>
                <div className="clearfix"></div>
            </div>}
            <div className="podium">
                {result[0] && <span className="first-place">
                    <span className="image"></span>
                    <span className="text">
                        <span className="left">1. mjesto</span>
                        <span className="right">{casino.utils.switchEurToKn(result[0].value) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                    </span>
                </span>}
                {result[1] && <span className="second-place">
                    <span className="image"></span>
                    <span className="text">
                        <span className="left">2. mjesto</span>
                        <span className="right">{casino.utils.switchEurToKn(result[1].value) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                    </span>
                </span>}
                {result[2] && <span className="third-place">
                    <span className="image"></span>
                    <span className="text">
                        <span className="left">3. mjesto</span>
                        <span className="right">{casino.utils.switchEurToKn(result[2].value) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                    </span>
                </span>}

            </div>
            <div className="placements">
                {result.map((place, index) => {
                    return index > 2 &&
                        <div key={index} className="placement">
                            <span>{place.rank}</span>
                            <span>{casino.utils.switchEurToKn(place.value) + ' ' + casino.utils.switchCurrencyKnToEur()}</span>
                        </div>
                }
                )}
            </div>
        </div>
    }

    renderLoading() {
        return <div>
            <div className="rectangle-bck"></div>
            <div className="rectangle-1 full"></div>
            <div className="rectangle-1 half left"></div>
            <div className="rectangle-1 half right red"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-2"></div>
            <div className="rectangle-1 full"></div>
            <div className="rectangle-1 half left"></div>
            <div className="rectangle-1 half right red"></div>
            <div style={{ 'clear': 'both' }}></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
            <div className="rectangle-1 full thin"></div>
        </div>
    }

    componentDidUpdate(prevProps) {
        if (this.props.userChecked && this.props.user == null) {
            this.setState({ navigate: true });
        }
    }

    render() {
        if (this.state.navigate) {
            if (this.state.raceId) {
                sessionStorage.setItem('casino-utrka', this.state.raceId);
            }
            return <Redirect to="/casino-utrke" push={true} />
        }

        return <div>
            <MetaTags title="Casino Utrke | Igraj Casino Igre i Osvoji Nagradu | SuperSport Casino | SuperCasino" description={"Ne propusti casino utrke tijekom cijele godine. Zaigraj omiljenu casino igru.  Uzbuđenje, zabava i nagrade su zagarantirane!"} />
            <Header key="header" {...this.state} {...this.props} disableBrowserBack={true}></Header>
            {this.renderHeader()}
            <div id="page-wrapper" className="no-padding grey">
                <div className="cu-container maximum margin-center" >
                    {!this.state.race && !this.state.raceLoaded && this.renderLoading()}
                    {this.state.race && this.renderRaceInfo()}
                    {!this.state.race && this.state.raceLoaded && this.renderRaceNotActive()}
                    {this.state.race && this.renderTabContent()}
                </div>
            </div>
            <GameDetails routePrefix={"/casino-utrke/" + this.state.raceId} loadGames={true}  {...this.props} {...this.state}></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>
    }
}